import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import LoginPage from './views/auth/login/LoginPage';
import RegisterPage from './views/auth/register/RegisterPage';
import FindPasswordPage from "./views/auth/findPassword/FindPasswordPage";
import ClientMainPage from "./views/client/main/ClientMainPage";
import ClientProjectMainPage from "./views/client/project/ClientProjectMainPage";
import Modal from "react-modal";
import ClientProjectInfoPage from "./views/client/project/ClientProjectInfoPage";
import ClientProjectRequestInfoPage from "./views/client/project/ClientProjectRequestInfoPage";
import CreateClientProjectRequestPage from "./views/client/project/CreateClientProjectRequestPage";
import EditClientProjectRequest from "./components/client/project/EditClientProjectRequest";
import ClientDocumentMainPage from "./views/client/document/ClientDocumentMainPage";
import ClientDocumentInfoPage from "./views/client/document/ClientDocumentInfoPage";
import ClientAccountMainPage from './views/client/account/ClientAccountMainPage';
import AdminMainPage from "./views/admin/main/AdminMainPage";
import AdminProjectMainPage from "./views/admin/project/AdminProjectMainPage";
import AdminProjectInfoPage from "./views/admin/project/AdminProjectInfoPage";
import EditAdminProjectInfo from "./components/admin/project/EditAdminProjectInfo";
import EditAdminProjectNote from "./components/admin/project/EditAdminProjectNote";
import RegisterTermPage from "./views/auth/register/RegisterTermPage";
import AdminProjectRequestPage from './views/admin/project/AdminProjectRequestPage';
import AdminClientPage from "./views/admin/client/AdminClientPage";
import AdminClientInfoPage from "./views/admin/client/AdminClientInfoPage";
import EditAdminClientInfo from "./components/admin/client/account/EditAdminClientInfo";
import AdminDocumentMainPage from "./views/admin/document/AdminDocumentMainPage";
import AdminDocumentInfoPage from "./views/admin/document/AdminDocumentInfoPage";
import EditAdminDocumentInfo from "./components/admin/document/EditAdminDocumentInfo";
import CreateAdminDocument from "./components/admin/document/CreateAdminDocument";
import AdminConfirmInfoPage from "./views/admin/document/AdminConfirmInfoPage";
import AdminSettingPage from "./views/admin/setting/AdminSettingPage";
import {AlertProvider} from "./components/common/error/AlertContext";
import {useEffect} from "react";
import {setupAlertInterceptor, setupTokenInterceptor} from "./services/base";
import HomePage from "./views/auth/home/HomePage";
import AdminBillingMainPage from "./views/admin/billing/AdminBillingMainPage";
import AdminWorkerRequestPage from "./views/admin/billing/AdminWorkerRequestPage";
import ClientBillingPage from "./views/client/billing/ClientBillingPage";
import ClientPaymentSuccessPage from "./views/client/billing/ClientPaymentSuccessPage";
import ClientBillingRegisterPage from "./views/client/billing/ClientBillingRegisterPage";
import AdminBillingInfoPage from "./views/admin/billing/AdminBillingInfoPage";
import AdminContractPage from "./views/admin/client/AdminContractPage";
import EditAdminContractInfo from "./components/admin/client/contract/EditAdminContractInfo";
import AdminContractInfoPage from "./views/admin/client/AdminContractInfoPage";
import AdminCreateProjectPage from "./views/admin/project/AdminCreateProjectPage";
import AdminTaxInvoiceInfoPage from "./views/admin/billing/AdminTaxInvoiceInfoPage";
import {ClientRoute} from "./components/client/route/ClientRoute";
import {AdminRoute} from "./components/admin/route/AdminRoute";
import EssentialRegisterPage from "./views/auth/register/EssentialRegisterPage";
import AdminRegularTaxInvoiceInfoPage from "./views/admin/billing/AdminRegularTaxInvoicePage";
import EditAdminRegularTaxInvoiceInfoPage from "./views/admin/billing/EditAdminRegularTaxInvoicePage";

Modal.setAppElement('#root');

//메인 루트
function App() {

    useEffect(() => {
        setupTokenInterceptor(); //토큰 관련 기능 인터셉터
        setupAlertInterceptor(); //알림 기능 인터셉터
    }, []);

    return (
        // 에러 발생 시 알림 출력
        <AlertProvider>
            <Router>
                {/*페이지별 주소 설정*/}
                <Routes>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/login" element={<LoginPage/>}/>
                    <Route path="/register" element={<RegisterPage/>}/>
                    <Route path="/register/term" element={<RegisterTermPage/>}/>
                    <Route path="/register/essential" element={<EssentialRegisterPage/>}/>
                    <Route path="/find-password" element={<FindPasswordPage/>}/>

                    {/* Client Routes */}
                    <Route path="/client" element={<ClientRoute><ClientMainPage /></ClientRoute>} />
                    <Route path="/client/projects" element={<ClientRoute><ClientProjectMainPage /></ClientRoute>} />
                    <Route path="/client/projects/:id" element={<ClientRoute><ClientProjectInfoPage /></ClientRoute>} />
                    <Route path="/client/projects/project-request/:id" element={<ClientRoute><ClientProjectRequestInfoPage /></ClientRoute>} />
                    <Route path="/client/projects/project-request" element={<ClientRoute><CreateClientProjectRequestPage /></ClientRoute>} />
                    <Route path="/client/projects/project-request/:id/edit" element={<ClientRoute><EditClientProjectRequest /></ClientRoute>} />
                    <Route path="/client/documents" element={<ClientRoute><ClientDocumentMainPage /></ClientRoute>} />
                    <Route path="/client/documents/:id" element={<ClientRoute><ClientDocumentInfoPage /></ClientRoute>} />
                    <Route path="/client/billing" element={<ClientRoute><ClientBillingPage /></ClientRoute>} />
                    <Route path="/client/billing/success" element={<ClientRoute><ClientPaymentSuccessPage /></ClientRoute>} />
                    <Route path="/client/billing/register" element={<ClientRoute><ClientBillingRegisterPage /></ClientRoute>} />
                    <Route path="/client/account" element={<ClientRoute><ClientAccountMainPage /></ClientRoute>} />

                    {/* Admin Routes */}
                    <Route path="/admin" element={<AdminRoute><AdminMainPage /></AdminRoute>} />
                    <Route path="/admin/projects" element={<AdminRoute><AdminProjectMainPage /></AdminRoute>} />
                    <Route path="/admin/projects/create" element={<AdminRoute><AdminCreateProjectPage /></AdminRoute>} />
                    <Route path="/admin/projects/:id" element={<AdminRoute><AdminProjectInfoPage /></AdminRoute>} />
                    <Route path="/admin/projects/:id/edit" element={<AdminRoute><EditAdminProjectInfo /></AdminRoute>} />
                    <Route path="/admin/projects/note/:id/edit" element={<AdminRoute><EditAdminProjectNote /></AdminRoute>} />
                    <Route path="/admin/projects/request/:id" element={<AdminRoute><AdminProjectRequestPage /></AdminRoute>} />
                    <Route path="/admin/clients/account" element={<AdminRoute><AdminClientPage /></AdminRoute>} />
                    <Route path="/admin/clients/account/:id" element={<AdminRoute><AdminClientInfoPage /></AdminRoute>} />
                    <Route path="/admin/clients/account/:id/edit" element={<AdminRoute><EditAdminClientInfo /></AdminRoute>} />
                    <Route path="/admin/clients/contract" element={<AdminRoute><AdminContractPage /></AdminRoute>} />
                    <Route path="/admin/clients/contract/:id" element={<AdminRoute><AdminContractInfoPage /></AdminRoute>} />
                    <Route path="/admin/clients/contract/:id/edit" element={<AdminRoute><EditAdminContractInfo /></AdminRoute>} />
                    <Route path="/admin/documents" element={<AdminRoute><AdminDocumentMainPage /></AdminRoute>} />
                    <Route path="/admin/documents/:id" element={<AdminRoute><AdminDocumentInfoPage /></AdminRoute>} />
                    <Route path="/admin/documents/:id/edit" element={<AdminRoute><EditAdminDocumentInfo /></AdminRoute>} />
                    <Route path="/admin/documents/create" element={<AdminRoute><CreateAdminDocument /></AdminRoute>} />
                    <Route path="/admin/documents/confirm/:id" element={<AdminRoute><AdminConfirmInfoPage /></AdminRoute>} />
                    <Route path="/admin/settings" element={<AdminRoute><AdminSettingPage /></AdminRoute>} />
                    <Route path="/admin/billing" element={<AdminRoute><AdminBillingMainPage /></AdminRoute>} />
                    <Route path="/admin/billing/worker-request/:id" element={<AdminRoute><AdminWorkerRequestPage /></AdminRoute>} />
                    <Route path="/admin/billing/payment/:id" element={<AdminRoute><AdminBillingInfoPage /></AdminRoute>} />
                    <Route path="/admin/billing/tax/:id" element={<AdminRoute><AdminTaxInvoiceInfoPage /></AdminRoute>} />
                    <Route path="/admin/billing/regular/:id" element={<AdminRoute><AdminRegularTaxInvoiceInfoPage /></AdminRoute>} />
                    <Route path="/admin/billing/regular/edit/:id" element={<AdminRoute><EditAdminRegularTaxInvoiceInfoPage /></AdminRoute>} />
                </Routes>
            </Router>
        </AlertProvider>
    );
}

export default App;